import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FilterState } from 'types';

const initialState: FilterState = {
  projectIds: [],
  dateRange: { type: 'week' },
  assigneeIds: [],
  status: 'pending',
};

const filterSlice = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<FilterState>) => {
      return action.payload;
    },
    updateFilters: (state, action: PayloadAction<Partial<FilterState>>) => {
      return { ...state, ...action.payload };
    },
    resetFilters: () => {
      return initialState;
    },
    setProjectFilter: (state, action: PayloadAction<string[]>) => {
      state.projectIds = action.payload;
    },
    setDateRangeFilter: (state, action: PayloadAction<FilterState['dateRange']>) => {
      state.dateRange = action.payload;
    },
    setAssigneeFilter: (state, action: PayloadAction<string[]>) => {
      state.assigneeIds = action.payload;
    },
    setStatusFilter: (state, action: PayloadAction<FilterState['status']>) => {
      state.status = action.payload;
    },
  },
});

export const {
  setFilters,
  updateFilters,
  resetFilters,
  setProjectFilter,
  setDateRangeFilter,
  setAssigneeFilter,
  setStatusFilter,
} = filterSlice.actions;
export default filterSlice.reducer;

